import { bruker as bruker_ } from './bruker';
import { jcamp as jcamp_ } from './jcamp';

export namespace Handlers {
  export const bruker = bruker_;
  export const jcamp = jcamp_;
}
